import React, { useState } from "react";
import { Tooltip } from "./Tooltip";
import { Button, ButtonProps } from "./Button";

interface TooltipButtonProps extends Omit<ButtonProps, "title"> {
  title: React.ReactNode;
  disableTooltip?: boolean;
  placement?: React.ComponentProps<typeof Tooltip>["placement"];
}

export const TooltipButton = ({
  title,
  disableTooltip = false,
  placement,
  onClick,
  ...buttonProps
}: TooltipButtonProps) => {
  const [hovered, setHovered] = useState(false);
  const [blocked, setBlocked] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setBlocked(true);
    onClick?.(e);
  };

  const open = !disableTooltip && !blocked && hovered;

  // The span stays mounted so the <button> node is stable for Popovers that
  // anchor on event.currentTarget.
  return (
    <Tooltip title={title} instant open={open} placement={placement}>
      <span
        className="inline-flex items-center justify-center"
        onPointerEnter={() => setHovered(true)}
        onPointerLeave={() => {
          setHovered(false);
          setBlocked(false);
        }}
      >
        <Button {...buttonProps} onClick={handleClick} />
      </span>
    </Tooltip>
  );
};
